import Index from './Component/Index';
import MainLayout from './MainLayout';

import Price from './Component/Price';
import Privacy from './Component/privacyPolicy';
import TermsConditions from './Component/termsConditions';
import Blog from './Component/Blog';
import BlogPost from './Component/BlogPost';
import FAQPage from './Component/FAQPage';

import './App.css';
import { useRef } from 'react';
import { BrowserRouter, Routes, Route } from "react-router";
import { HelmetProvider } from 'react-helmet-async';
import AboutUs from './Component/aboutUs';
function App() {
  
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />} >
            <Route path='/' element={<Index />} />
            <Route path='/pricing-plans' element={<Price />} />
            <Route path='/blog' element={<Blog />} />
            <Route path='/blog/:slug' element={<BlogPost />} />
            <Route path='/privacypolicy' element={<Privacy />} />
            <Route path='/terms' element={<TermsConditions />} />
            <Route path='/faq' element={<FAQPage />} />
            <Route path='/about-us' element={<AboutUs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
